import { render } from "./day.vue?vue&type=template&id=4b17aa40&scoped=true"
import script from "./day.vue?vue&type=script&lang=js"
export * from "./day.vue?vue&type=script&lang=js"

import "./day.vue?vue&type=style&index=0&id=4b17aa40&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b17aa40"]])

export default __exports__